/*
  Vídeos decorativos da Aconchegue (snippets/aconchegue-video.liquid).
  - Toca só enquanto o vídeo está na tela; fora dela, pausa. Como o vídeo usa
    preload="none", nada é baixado antes de ele aparecer.
  - Com prefers-reduced-motion, começa pausado (fica a capa); o botão permite tocar.
  - O botão de pausar atende à regra de acessibilidade para movimento automático.
  - Vídeos escondidos por CSS (ex.: versão de celular no desktop) nunca entram na tela,
    então não tocam nem baixam.
*/
if (!customElements.get('aconchegue-video')) {
  const reduzirMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');

  class AconchegueVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.botao = this.querySelector('.aconchegue-video__botao');
      if (!this.video || !this.video.querySelector('source')) return;

      this.video.muted = true;
      this.pausadoPeloUsuario = reduzirMovimento.matches;
      this.visivel = false;

      if (this.botao) {
        this.botao.hidden = false;
        this.botao.addEventListener('click', () => this.alternar());
        this.video.addEventListener('play', () => this.atualizarBotao());
        this.video.addEventListener('pause', () => this.atualizarBotao());
        this.atualizarBotao();
      }

      if (!('IntersectionObserver' in window)) {
        if (!this.pausadoPeloUsuario) this.tocar();
        return;
      }

      this.observer = new IntersectionObserver(
        ([entrada]) => {
          this.visivel = entrada.isIntersecting;
          if (this.visivel && !this.pausadoPeloUsuario) {
            this.tocar();
          } else {
            this.video.pause();
          }
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    tocar() {
      const promessa = this.video.play();
      if (promessa) promessa.catch(() => {});
    }

    alternar() {
      if (this.video.paused) {
        this.pausadoPeloUsuario = false;
        this.tocar();
      } else {
        this.pausadoPeloUsuario = true;
        this.video.pause();
      }
    }

    atualizarBotao() {
      const pausado = this.video.paused;
      this.botao.setAttribute('aria-label', pausado ? 'Reproduzir vídeo' : 'Pausar vídeo');
      this.classList.toggle('aconchegue-video--pausado', pausado);
    }
  }

  customElements.define('aconchegue-video', AconchegueVideo);
}
